import React from 'react';

/**
 * Customer Journey icon with green gradient
 * Represents timeline, history, and customer journey tracking
 * @param {string} width - SVG width (default: 20)
 * @param {string} height - SVG height (default: 20)
 * @param {string} color - Icon color (if provided, overrides gradient)
 * @param {string} className - Additional CSS classes
 */
export default function CustomerJourney({
  width = '20',
  height = '20',
  color,
  className = '',
}) {
  // If a color is provided, use it instead of the gradient
  const strokeColor = color || 'url(#paint0_linear_customer_journey)';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.0056 10C17.0056 14.4183 13.423 18 9.00354 18C4.58412 18 1.00146 14.4183 1.00146 10C1.00146 5.58172 4.58412 2 9.00354 2C11.9654 2 14.5515 3.60879 15.9351 6M14.8104 10.8779L16.8109 8.87792L18.8115 10.8779M12.0015 12.1814L9.00146 11.1814V7"
        stroke={strokeColor}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {!color && (
        <defs>
          <linearGradient
            id="paint0_linear_customer_journey"
            x1="18.9995"
            y1="2"
            x2="0.499512"
            y2="17.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DB782" />
            <stop offset="1" stopColor="#018854" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}
